import type { CreateSetup } from '@here/api'
import { type FormStore, getValues, setValue } from '@modular-forms/solid'
import { calculateValues } from './utils/calculateValues'
import { findMiddle } from './utils/findMiddle'
import { getpatternSpecification } from './utils/getpatternSpecification'
import { isSetupLogScale } from './utils/isSetupLogScale'

export const updateComputedFields = (form: FormStore<CreateSetup, undefined>) => {
	const formValues = getValues(form)

	// need the direction to be either set manually, or derived from the diffeence between the time.
	if (formValues.position === undefined) {
		return
	}

	const isLog = isSetupLogScale(formValues as CreateSetup)
	const isLong = formValues.position === 'long'

	const values = [
		formValues.high_1_price,
		formValues.low_1_price,
		formValues.high_2_price,
		formValues.low_2_price,
		formValues.high_3_price,
		formValues.low_3_price,
	]

	// check that every value is a number and greater than 0
	if (values.some((v) => v === null || v === undefined || isNaN(v) || v <= 0)) {
		return
	}

	const axis = findMiddle(formValues.high_3_price!, formValues.low_3_price!)
	const patternSpecification = getpatternSpecification(
		formValues.high_1_price!,
		formValues.low_1_price!,
		axis,
		isLong,
	)

	const { target, interim2, interim1, riskRewardRatio } = calculateValues(
		formValues.high_1_price!,
		formValues.high_2_price!,
		formValues.high_3_price!,
		formValues.low_1_price!,
		formValues.low_2_price!,
		formValues.low_3_price!,
		axis,
		isLong,
		isLog,
	)

	setValue(form, 'axis', axis)
	setValue(form, 'risk_reward_ratio', Math.round(riskRewardRatio * 100) / 100)
	setValue(form, 'interim_1', interim1)
	setValue(form, 'interim_2', interim2)
	setValue(form, 'target', target)
	setValue(form, 'pattern_specification', patternSpecification)
}
